import { Link } from 'react-router-dom';
import { SectionHeader } from '@/components/ui/SectionHeader';
import { Skeleton } from '@/components/ui/Skeleton';
import { ErrorState } from '@/components/ui/StateMessage';
import { useGenres } from '@/hooks/useAnimeQueries';

/** Danh sách thể loại thật từ GET /the-loai, mỗi thẻ dẫn sang trang Duyệt. */
export function GenresPage() {
	const genresQuery = useGenres();

	return (
		<section className="mt-6">
			<SectionHeader title="Thể loại hoạt hình" />

			{genresQuery.isPending && (
				<div className="grid grid-cols-2 gap-3 min-[700px]:grid-cols-3 min-[1100px]:grid-cols-5">
					{Array.from({ length: 15 }, (_, index) => (
						<Skeleton key={index} className="h-20 w-full rounded-panel" />
					))}
				</div>
			)}

			{genresQuery.error && (
				<ErrorState
					error={genresQuery.error}
					onRetry={() => void genresQuery.refetch()}
				/>
			)}

			{genresQuery.data && (
				<div className="grid grid-cols-2 gap-3 min-[700px]:grid-cols-3 min-[1100px]:grid-cols-5">
					{genresQuery.data.map((genre) => (
						<Link
							key={genre.slug}
							to={`/duyet?category=${genre.slug}`}
							className="group relative overflow-hidden rounded-panel border border-line bg-linear-to-br from-[#14172b] to-[#101221] px-4 py-5 transition hover:-translate-y-0.5 hover:border-accent/50"
						>
							<span
								className="absolute -top-8 -right-8 size-24 rounded-full bg-linear-to-br from-accent/25 to-iris/25 opacity-0 blur-xl transition group-hover:opacity-100"
								aria-hidden="true"
							/>
							<strong className="relative block text-base">{genre.name}</strong>
							<span className="relative text-xs text-muted">
								Xem danh sách →
							</span>
						</Link>
					))}
				</div>
			)}
		</section>
	);
}
